module.exports = __webpack_public_path__ + "img/icn_scarpa_edit_3_selezionata.e18d9a12.png";